import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Route-level guard for /painters/apply.
 *
 * If the current user is the platform owner (is_owner === true), redirect to
 * /painter (owner-preview dashboard) instead of rendering the application
 * form. Runs before the wrapped page mounts, so the form is never rendered,
 * submitted, or triggers HTML5 required-field validation for owners.
 *
 * Behaviour matrix:
 *   user === null           → auth probe loading, render nothing (avoids flash)
 *   user === false          → anonymous, render the wrapped page as normal
 *   user && !is_owner       → regular customer / painter applicant, render normally
 *   user && is_owner        → redirect to /painter with replace:true
 */
export default function OwnerRedirectToPainter({ children }) {
  const { user } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (user && user.is_owner) {
      nav("/painter", { replace: true });
    }
  }, [user, nav]);

  if (user === null) return null;
  if (user && user.is_owner) return <Navigate to="/painter" replace />;
  return children;
}
